<template lang='pug'>
  div
    v-btn(v-if='hasVideo' text icon, :href='getVideoUrl(testRun)', target='_blank')
      v-icon(:size='size') ondemand_video
    v-tooltip(bottom v-if='!hasVideo')
      template(v-slot:activator='{on}')
        div(v-on='on')
          v-btn(text icon :href='getVideoUrl(testRun)' :disabled='true')
            v-icon(:size='size') ondemand_video
      span Video Disabled for Parallel Runs
</template>

<script>
import _ from 'lodash';

export default {
  name: 'BionicMetricsVideoPlayer',
  props: {
    testRun: {
      type: Object
    },
    size: {
      type: Number,
      default: 24
    },
    index: {
      type: Number,
      default() {
        return null;
      }
    }
  },
  computed: {
    hasVideo() {
      return this.testRun && !this.testRun.parallel && !this.testRun.noBrowser;
    }
  },
  methods: {
    getBaseUrl(testRun) {
      return `${process.env.VUE_APP_VIDEO_URL}/${testRun.testSuiteGuid}/${testRun.guid}${testRun.agentGuid ? `/${testRun.agentGuid}` : ''}`;
    },
    getFileName(testRun) {
      return `${testRun.agentGuid ? '' : '/video'}${testRun.rerun ? `_${testRun.rerun}` : ''}.webm`;
    },
    getVideoUrl(testRun) {
      if (_.isNumber(this.index)) {
        if (testRun.tests[this.index].rerun) return `${this.getBaseUrl(testRun)}/${this.index}_${testRun.tests[this.index].rerun}.webm`;
        return `${this.getBaseUrl(testRun)}/${this.index}.webm`;
      }
      return `${this.getBaseUrl(testRun)}${this.getFileName(testRun)}`;
    }
  }
};
</script>

<style scoped>
  .video {
    width: 100%;
    height: 100%;
  }
</style>
